import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import AppDropdown from 'components/Dropdown/Dropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import Slider from 'components/Slider/Slider';
import Sidebar from 'components/Sidebar/Sidebar';
import AppButton from "components/Button/Button";
import HomeClipList from 'components/HomeClip/ClipList/ClipList';
import ClipDetail from 'pages/ClipDetail/ClipDetail';
import ItemDetail from 'pages/ItemDetail/ItemDetail';
import WorkDetail from 'pages/WorkPage/WorkDetail/WorkDetail';
import HomeView from 'pages/HomeView/HomeView';
import { getSearchFields, EmailBox, PhoneBox, LinkBox } from "helpers/FieldHelper";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFolder } from "@fortawesome/free-solid-svg-icons";
import * as ConfigTypes from 'config/ConfigTypes';
import { setScrollTop } from "helpers/PageHelper";
import { getMetaConfig } from "helpers/ConfigHelper";
import SearchBox from "pages/SearchPage/SearchBox/SearchBox";
import SearchFilter from "pages/SearchPage/SearchFilter/SearchFilter";
import { getClipById } from "helpers/ClipHelper";
import { getBaseName, isHome, checkSearchApp, showConfirmMsgDlg } from 'helpers/AppHelper';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import Footer from "layouts/Footer/Footer";
import Authentication from "pages/Authentication/Authentication";
import CartListPage from "pages/CartPage/CartListPage/CartListPage";
import CartMessage from "pages/CartPage/CartMessage/CartMessage";
import CartRequest from "pages/CartPage/CartRequest/CartRequest";
import CartMainPage from "pages/CartPage/CartMainPage/CartMainPage";
import Profile from "pages/UserPage/ProfilePage/ProfilePage";
import { subAfter } from "helpers/TypeHelper";

import './MainPage.scss'

const MainPage = observer(
    class MainPage extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
                laneItems: ConfigTypes.HOME_LEFT_SIDE_ITEMS,
                cliplist: [],
                laneWorkList: [],
                currentClip: {},
                loading: false,
                searchText: '',
                currentDDItem: '',
                clStyles: { [ConfigTypes.GRID]: ConfigTypes.BTN_ACTIVE },
                baseName: getBaseName(),
                laneStyles: {},
            }
        }

        checkClipPath = (id) => {
            const { cliplist, currentClip } = this.props.mediaObjects;
            this.setState({ loading: true });
            let pathClip = getClipById({ id, cliplist });
            if (pathClip) {
                if ((currentClip && +currentClip.id !== +pathClip.id) || !currentClip) {
                    this.setState({ currentClip: pathClip, viewMode: ConfigTypes.DETAIL, });
                    let updated = {
                        currentClip: pathClip,
                        viewMode: ConfigTypes.DETAIL,
                        openVideoPlayer: true
                    };
                    this.props.updateMediaObjects(updated);
                }
            } else {
                this.setState({ currentClip: currentClip, viewMode: ConfigTypes.DETAIL });
                this.props.getObject({ objectId: id });
                this.props.updateMediaObjects({ viewMode: ConfigTypes.DETAIL, openVideoPlayer: true });
            }
            this.setState({ loading: false });
        }

        checkObjectdetailsPath = (objectDetailsId) => {
            if (objectDetailsId && objectDetailsId.startsWith(ConfigTypes.PATH_START)) {
                const { currentClip } = this.props.mediaObjects;
                let prirefId = subAfter(objectDetailsId, ConfigTypes.PATH_START);
                this.setState({ currentClip: currentClip, viewMode: ConfigTypes.DETAIL });
                this.props.getObjectdetailsByPriref({ prirefId });
                this.props.updateMediaObjects({ viewMode: ConfigTypes.DETAIL, openVideoPlayer: true });
                this.setState({ loading: false });
            }
        }

        checkItemPath = (id) => {
            const { itemlist, currentClip } = this.props.mediaObjects;
            this.setState({ loading: true });
            let pathClip = getClipById({ id, itemlist });
            if (pathClip) {
                if ((currentClip && +currentClip.id !== +pathClip.id) || !currentClip) {
                    this.setState({ currentClip: pathClip, viewMode: ConfigTypes.DETAIL, });
                    let updated = {
                        currentClip: pathClip,
                        viewMode: ConfigTypes.DETAIL,
                        openVideoPlayer: true
                    };
                    this.props.updateMediaObjects(updated);
                }
            } else {
                this.setState({ currentClip: currentClip, viewMode: ConfigTypes.ITEM_DETAIL });
                this.props.getItem({ itemId: id });
                this.props.updateMediaObjects({ viewMode: ConfigTypes.ITEM_DETAIL, openVideoPlayer: true });
            }
            this.setState({ loading: false });
        }

        checkItemdetailsPath = (itemdetailsId) => {
            const { currentClip } = this.props.mediaObjects;
            if (itemdetailsId.startsWith(ConfigTypes.PATH_START)) {
                this.setState({ currentClip: currentClip, viewMode: ConfigTypes.ITEM_DETAIL });
                let prirefId = subAfter(itemdetailsId, ConfigTypes.PATH_START);
                this.props.getItemdetailsByPriref({ prirefId });
                this.props.updateMediaObjects({ viewMode: ConfigTypes.ITEM_DETAIL, openVideoPlayer: true });
            }
        }

        checkWorkPath = (workId) => {
            let updated = {
                viewMode: ConfigTypes.WORK_DETAIL,
            };
            this.props.getWork({ workId });
            this.props.updateMediaObjects(updated);
        }

        checkWorkdetailsPath = (workdetailsId) => {
            if (workdetailsId && workdetailsId.startsWith(ConfigTypes.PATH_START)) {
                let updated = {
                    viewMode: ConfigTypes.WORK_DETAIL,
                };
                let prirefId = subAfter(workdetailsId, ConfigTypes.PATH_START);
                this.props.getWorkdetailsByPriref({ prirefId });
                this.props.updateMediaObjects(updated);
            }
        }

        checkCollectionPath = (priref) => {
            if (priref) {
                let updated = { viewMode: ConfigTypes.LIST };
                this.setState({ autoLoading: true });
                this.props.updateMediaObjects(updated);
                setTimeout(() => {
                    this.props.updateMediaObjects({ collectionId: priref });
                    this.setState({ autoLoading: false });
                }, ConfigTypes.AUTO_TIME);
            }
        }

        checkPaths = () => {
            if (this.props.router && this.props.router.params) {
                const { id, workId, itemId, workdetailsId, itemdetailsId, objectdetailsId, priref }
                    = this.props.router.params;

                if (id) return this.checkClipPath(id);
                if (workId) return this.checkWorkPath(workId);
                if (itemId) return this.checkItemPath(itemId);
                if (workdetailsId) return this.checkWorkdetailsPath(workdetailsId);
                if (itemdetailsId) return this.checkItemdetailsPath(itemdetailsId);
                if (objectdetailsId) return this.checkObjectdetailsPath(objectdetailsId);
                if (priref) return this.checkCollectionPath(priref);
            }
        }


        onSearchSortClick = (item) => {
            this.setState({ searchSortCurrent: item });
            this.props.updateMediaObjects({ searchSortCurrent: item });
        }

        onSortArrowClick = (sort) => () => {
            const { keyword } = this.props.mediaObjects;
            const fields = getSearchFields(this.state.searchSortCurrent, sort);
            this.props.searchObjects({ keyword: keyword, fields });
        }

        toggleViewMode = (view) => () => {
            this.setState({
                viewMode: view,
                clStyles: { [view]: ConfigTypes.BTN_ACTIVE }
            });
            this.props.updateMediaObjects({ viewMode: view });
        }

        showSearchPage = () => {
            return (
                <div className="row">
                    <div className="col-12 mx-auto">
                        <SearchBox />
                    </div>
                </div>)
        }

        showLeftSide = () => {
            return this.state.laneItems.map(item => {
                return (
                    <div className={`mainpage-leftside-item ${this.state.laneStyles[item.name]}`}
                        style={item.isExtraLane && { display: 'none' }}
                        onClick={item.onClick && this[item.onClick](item)}>
                        <span className="mainpage-icon">{item.icon && <FontAwesomeIcon icon={item.icon} />}</span>
                        <span>{this.props.intl.formatMessage({ id: item.intl })}</span>
                    </div>)
            })
        }

        showRightSide = () => {
            return (
                <div className="mainpage-sidebar-box">
                    {!this.state.loading && <Sidebar
                        clips={this.props.mediaObjects.clipLength}
                        currentSlidePos={this.props.mediaObjects.currentSlidePos}
                        mainObj={this.props.mediaObjects} mainObjName="mediaObjects"
                        updateObjects={this.props.updateMediaObjects}
                        mediaCount={this.props.mediaObjects.mediaCount || '0'}
                        slideItems={this.state.cliplist.length}>
                        <HomeClipList items={this.state.cliplist} />
                    </Sidebar>}
                </div>
            )
        }

        showSortDD = () => {
            if (this.state && this.state.data && this.state.data.length)
                return (
                    <div className="mainpage-dd-box">
                        <AppDropdown
                            data={this.state.data} current={this.state.searchSortCurrent}
                            onDDClick={this.onSearchSortClick} />
                        <div>
                            {ConfigTypes.SORT_ICON_BTNS.map((item, i) => (
                                <span key={`mainpageSortIcon${i}`}>
                                    <FontAwesomeIcon icon={item.icon}
                                        onClick={this.onSortArrowClick(item.name)} />
                                </span>))}
                        </div>
                    </div>);
            return <div></div>
        }

        onBtnClick = (viewMode) => () => {
            if (viewMode === ConfigTypes.HOME) {
                this.setState({ searchText: "", viewMode });
                this.props.updateMediaObjects({ keyword: "", viewMode, currentPage: 1 });
                if (!isHome()) this.props.router.navigate("/");
            } else {
                this.setState({ viewMode });
                this.props.updateMediaObjects({ viewMode });
                this.props.router.navigate(-1);
            }
        }

        onKeyUp = (e) => {
            if (e.key === ConfigTypes.ENTER) {
                this.startPortalSearch();
            }
        }

        onNewSearchClick = (viewMode) => () => {
            this.setState({ searchText: "", viewMode });
            this.props.updateMediaObjects({ keyword: "", viewMode, currentPage: 1 });
            if (!isHome()) this.props.router.navigate("/")
        }

        showNewSearch = () => {
            return (<AppButton icon={faSearch}
                btnTxt={this.props.intl.formatMessage({ id: "mainpage.newsearch" })}
                onClick={this.onNewSearchClick(ConfigTypes.SEARCH_PAGE)} />)
        }

        showBack = () => {
            let lastView = ConfigTypes.GRID;
            if (this.props.mediaObjects.lastView) {
                lastView = this.props.mediaObjects.lastView;
            }

            return (
                <Button className="mainpage-btn-newsearch ms-4"
                    onClick={this.onBtnClick(lastView)}>
                    {this.props.intl.formatMessage({ id: "mainpage.back" })}
                </Button>
            )
        }

        initDropdown = () => {
            const data = getMetaConfig({
                viewMode: ConfigTypes.SEARCH_SORT,
                props: this.props, configName: ConfigTypes.OBJECT
            });
            if (data && data.length) {
                this.setState({ data: data, searchSortCurrent: data[0] });
            }
        }

        showHomeContent = () => {
            if (this.state.viewMode === ConfigTypes.HOME)
                return (
                    <div className="col-12 mx-auto mainpage-content-box">
                        <div className="row display-flex">
                            <h1 className="mainpage-search-heading">{ConfigTypes.HOME_SEARCH}</h1>
                        </div>
                        <div className="row display-flex">
                            <div className="col-sm-12 col-md-5 mx-auto">
                                <p>{ConfigTypes.HOME_TEXT}</p>
                            </div>
                            <div className="col-sm-12  col-md-5 mx-auto">
                                <div className="input-group mainpage-search-wrapper">
                                    <input type="text" className="form-control" value={this.state.searchText}
                                        placeholder="Suche"
                                        onChange={this.onChangeHandle}
                                        aria-label="Sizing example input"
                                        aria-describedby="inputGroup-sizing-default" />
                                    <div className="mainpage-search-icon" onClick={this.searchFullText}>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )
        }

        showHomeBody = () => {
            return (
                <div className="mainpage-body-container">
                    <div className="mainpage-body-left">
                        {this.showLeftSide()}
                    </div>
                    <div className="mainpage-body-center">
                        {checkSearchApp() ? <div /> : <HomeView clip={this.state.currentClip} />}
                    </div>
                    <div className="mainpage-body-right">
                        {this.showRightSide()}
                    </div>
                </div>
            )
        }

        initPresets = () => {
            const { currentClip } = this.props.mediaObjects;
            ConfigTypes.HOME_SEARCH_DD_ITEMS.forEach(item => {
                if (item.active) {
                    this.setState({ currentDDItem: item });
                }
            });
            this.setState({
                viewMode: this.props.mediaObjects.viewMode,
                currentClip: currentClip || {},
                showHome: true
            });
            this.initDropdown();
        }

        setToTop = (prev) => {
            if (!prev.mediaObjects.toTop && this.props.mediaObjects.toTop) {
                setScrollTop("mainpageTabId");
                this.props.updateMediaObjects({ toTop: false });
            }
        }

        setViewMode = (prev) => {
            const { viewMode, currentClip } = this.props.mediaObjects;

            if (prev.mediaObjects.currentClip != currentClip) {
                this.setState({ viewMode: ConfigTypes.HOME, currentClip: currentClip });
            }

            if (prev.mediaObjects.viewMode != viewMode) {
                this.setState({ viewMode: viewMode });
                this.props.updateMediaObjects({ trailerPlaying: false });
            }
        }

        initAllDropdowns = (prev) => {
            if (prev.mediaObjects.objectMeta != this.props.mediaObjects.objectMeta) {
                this.initDropdown();
            }
        }

        checkClipList = (prev) => {
            if (prev.mediaObjects.cliplist != this.props.mediaObjects.cliplist) {
                this.setState({ cliplist: this.props.mediaObjects.cliplist });
                this.checkPaths();
            }
        }

        checkWorkList = (prev) => {
            if (prev.mediaObjects.worklist != this.props.mediaObjects.worklist) {
                this.setState({ worklist: this.props.mediaObjects.worklist });
                this.checkPaths();
            }
        }

        checkAndStartSearchApp = () => {
            if (checkSearchApp()) {
                this.setState({ loading: true });
                setTimeout(() => {
                    if (!isHome()) this.props.router.navigate("/");
                    this.props.updateMediaObjects({ viewMode: ConfigTypes.SEARCH_PAGE });
                    this.setState({ viewMode: ConfigTypes.SEARCH_PAGE });
                    this.setState({ loading: false });
                }, 1000);
            }
        }

        //PORTALSEARCH
        onChangeHandle = (e) => this.setState({ searchText: e.target.value || '' });
        onDDItemClick = (item) => () => this.setState({ currentDDItem: item });

        onRentalFilm = () => {
            if (this.state.rental) this.setState({ advancedClass: '', rental: '' });
            else this.setState({ advancedClass: 'mainpage-active', rental: true })
        }

        initPortalSearch = () => {
            const { workKeyword, portalSearchRental } = this.props.mediaObjects;
            this.setState({ viewMode: ConfigTypes.HOME, searchText: workKeyword ? workKeyword : '' });
            //  this.props.updateMediaObjects({ viewMode, keyword: this.state.searchText });
            this.checkPaths();

            this.setState({
                rental: portalSearchRental ? true : '',
                advancedClass: portalSearchRental ? 'mainpage-active' : ''
            });
        }

        updatePortalHome = (prev) => {
            const { initApp, viewMode, portalCurrentDDItem, portalSearchRental } = this.props.mediaObjects;
            if (ConfigTypes.REFRESH_HOME) {
                if (viewMode === ConfigTypes.HOME) {
                    if (!prev.mediaObjects.initApp && initApp) this.initPortalSearch();
                }
            } else {
                if (initApp && prev.mediaObjects.viewMode !== viewMode
                    && viewMode === ConfigTypes.HOME) {
                    this.initPortalSearch();
                }
            }

            if (prev.mediaObjects.portalCurrentDDItem != portalCurrentDDItem) {
                this.setState({ currentDDItem: portalCurrentDDItem });
            }

            if (!prev.mediaObjects.initApp && initApp) {
                this.initPortalSearch();
                this.checkConnection();
            }
        }

        showSearchDD = () => {
            return (<Dropdown size="lg" className="mainpage-search-dd">
                <Dropdown.Toggle variant="light" id="dropdown-basic">
                    {this.props.intl.formatMessage({ id: this.state.currentDDItem.intl })}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {ConfigTypes.HOME_SEARCH_DD_ITEMS.map((item, i) => (
                        <Dropdown.Item href="#" key={`mainpageSearchDD${i}`}
                            onClick={this.onDDItemClick(item)}>
                            {this.props.intl.formatMessage({ id: item.intl })}
                        </Dropdown.Item>))}
                </Dropdown.Menu>
            </Dropdown>)
        }

        startPortalSearch = () => {
            let workSearch = true;
            let fields = [];
            let workFields = [];
            let viewMode = ConfigTypes.LIST;
            let ddCurrent = this.state.currentDDItem;
            let portalSearchWorkMain = null;
            let keyword = this.state.searchText;
            let type = ConfigTypes.DEFAULT_SEARCH_TYPE;
            if (ddCurrent && ddCurrent.name && ddCurrent.name !== ConfigTypes.ALL) {
                fields = getSearchFields(ddCurrent, ConfigTypes.ASC);
                workFields = [...fields];
                portalSearchWorkMain = { field: ddCurrent.name, type, value: this.state.searchText };
                workFields.push(portalSearchWorkMain);
                keyword = '';
            }
            if (this.state.rental) workFields.push(ConfigTypes.RENTALOBJ);
            let searchParams = { fields: workFields, keyword };
            this.props.searchWorks(searchParams);
            this.setState({ viewMode });
            let updated = {
                viewMode, workSearch,
                workKeyword: this.state.searchText,
                objectKeyword: this.state.searchText,
                workFields: workFields,
                portalSearchWorkMain,
                portalCurrentDDItem: ddCurrent,
            };

            if (this.state.rental) updated.portalSearchRental = ConfigTypes.RENTALOBJ;
            else updated.portalSearchRental = null;

            this.props.updateMediaObjects(updated);
        }

        showCarousel = () => {
            return (
                <div className="row">
                    <div className="col-12 mx-auto">
                        <Slider formatMessage={(id) => this.props.intl.formatMessage({ id: id })} />
                    </div>
                </div>)
        }

        showItemList = (item) => {
            return (
                <>
                    {item.listHeadingIntl && (
                        <p className="mainpage-content-list-heading">
                            {this.props.intl.formatMessage({ id: item.listHeadingIntl })}
                        </p>
                    )}
                    <ul>
                        {item.list.map(el => <li>{this.props.intl.formatMessage({ id: el.intl })}</li>)}
                    </ul>
                </>
            )
        }

        showItemListLink = (item) => {
            return (
                <>
                    {item.listHeadingIntl && (
                        <p className="mainpage-content-list-heading">
                            {this.props.intl.formatMessage({ id: item.listHeadingIntl })}
                        </p>
                    )}
                    <ul>
                        {item.listWithLink.map(el => (
                            <li>{this.props.intl.formatMessage({ id: el.intl })}
                                <a className="mainpage-listlink-a" href={item.listLinkUrl}>
                                    {this.props.intl.formatMessage({ id: item.listLinkTxt })}
                                </a>
                                {this.props.intl.formatMessage({ id: item.listLinkAddTo })}
                            </li>
                        ))}
                    </ul>
                </>
            )
        }

        showPortalSearchContent = () => {
            return (
                ConfigTypes.HOME_CONTENT_ITEMS.map((item, i) => (
                    <div className="row display-flex mainpage-recherche-body-wrapper "
                        key={`clippageContentItem${i}`}>
                        <div className="col-sm-12 col-md-8 mainpage-content-wrapper">
                            {item.heading && <h2>{item.heading}</h2>}
                            {item.subHeading && <h3>{this.props.intl.formatMessage({ id: item.subHeading })}</h3>}
                            {item.texte && item.texte.map((el, i) => {
                                if (el.html === ConfigTypes.EMAIL) return <EmailBox el={el} key={`clippageEmailBox${i}`} />
                                if (el.html === ConfigTypes.LINK) return (
                                    <LinkBox el={el} intl={this.props.intl.formatMessage({ id: el.intl })}
                                        key={`clippageEmailBox${i}`} htmlClasses="mainpage-content-btnlink" />
                                )
                                if (el.html === ConfigTypes.PHONE) return <PhoneBox el={el} key={`clippagePhoneBox${i}`} />
                                if (el.noSpace) return <div key={`clippageSpace${i}`}>{el.value}</div>
                                if (el.intl) return <div>{this.props.intl.formatMessage({ id: el.intl })}</div>
                                return <p key={`clippageParaph${i}`}>{el.value}</p>
                            })}
                            {item.list && this.showItemList(item)}
                            {item.listWithLink && this.showItemListLink(item)}
                        </div>
                    </div>
                ))
            )
        }

        showPortalSearchBody = () => {
            if (this.state.viewMode === ConfigTypes.HOME)
                return (
                    <div className="mainpage-body-box">
                        <div className="row display-flex mainpage-recherche-body-wrapper ">
                            <div className="col-sm-12 col-md-8 mainpage-recherche-body-wrapper">
                                {/*  <div className="mainpage-search-dd ">{this.showSearchDD()}</div> */}
                                <div className="input-group mainpage-search-wrapper"
                                    onKeyDown={this.handleKeyDown} id="ClipPageSearchDivId">
                                    <input className="form-control mainpage-search-input" value={this.state.searchText}
                                        onChange={this.onChangeHandle} type="text" onKeyUp={this.onKeyUp}
                                        placeholder={this.props.intl.formatMessage({ id: "home.search.search" })}
                                        aria-label="Portalsearch input" aria-describedby="inputGroup-sizing-default" />
                                    <div className="mainpage-search-icon" onClick={this.startPortalSearch}>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </div>
                                    <div className={`mainpage-search-advanced ${this.state.advancedClass}`}
                                        onClick={this.onRentalFilm}>
                                        {this.props.intl.formatMessage({ id: "mainpage.rentalfilm" })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.showPortalSearchContent()}
                    </div>
                )
        }

        showPortalSearch = () => {
            return (
                <div className="mainpage-wrapper">
                    {this.showCarousel()}
                    {this.showPortalSearchBody()}
                </div>
            )
        }

        showCartRequest = () => {
            return (
                <div className="mainpage-wrapper">
                    <CartRequest />
                </div>
            )
        }

        showCartMainPage = () => {
            return (
                <div className="mainpage-wrapper">
                    <CartMainPage />
                </div>
            )
        }


        showMainPage = () => {
            const { viewMode } = this.props.mediaObjects;
            switch (viewMode) {
                case ConfigTypes.GRID:
                case ConfigTypes.LIST:
                    return <SearchFilter />
                case ConfigTypes.DETAIL:
                    return <ClipDetail />;
                case ConfigTypes.ITEM_DETAIL:
                    return <ItemDetail />;
                case ConfigTypes.CAROUSEL:
                    return this.showCarousel();
                case ConfigTypes.WORK_DETAIL:
                    return <WorkDetail />;
                case ConfigTypes.SEARCH_PAGE:
                    return this.showSearchPage();
                case ConfigTypes.HOME:
                    return this.showPortalSearch();
                case ConfigTypes.CART_MAINPAGE:
                    return this.showCartMainPage();
                case ConfigTypes.CART_REQUEST:
                    return this.showCartRequest();
                default:
                    return <div>{viewMode}</div>
            }
        }

        renderApp = () => {
            return (
                <div>
                    <div className="row mainpage-tab" id="mainpageTabId">
                        {this.showMainPage()}
                        <Footer />
                    </div>
                    {/* <div className="row mainpage-content">
                    </div> */}
                </div>
            )
        }

        formatMessage = ({ id }) => this.props.intl.formatMessage({ id });

        checkConnection = () => {
            let showAlert = false;
            let htmlMsg = this.formatMessage({ id: "data.msg.lostconnect" });
            let connectInt = setInterval(() => {
                if (!window.flow.socket || (window.flow.socket && window.flow.socket.readyState !== 1)) {
                    if (!showAlert) {
                        showConfirmMsgDlg({
                            htmlMsg, formatMessage: this.formatMessage, cb: () => {
                                this.props.updateAuthObjects({ shouldLogOut: true });
                                window.location.reload();
                                clearInterval(connectInt);
                            }
                        });
                        showAlert = true;
                    }
                }
            }, ConfigTypes.CHECK_CONN_TIME);
        }

        componentDidUpdate(prev, prevState) {
            this.checkClipList(prev);
            this.checkWorkList(prev);
            this.setToTop(prev);
            this.setViewMode(prev);
            this.initAllDropdowns(prev);
            this.updatePortalHome(prev);
        }

        componentDidMount() {
            const { initApp } = this.props.mediaObjects;
            this.initPresets();
            if (initApp) {
                this.initPortalSearch();
                this.checkConnection();
            }
        }

        render() {
            return (
                <div className="mainpage">
                    <Authentication />
                    <Profile />
                    {/* <CartListPage /> */}
                    <CartMessage />
                    {this.renderApp()}
                    {(this.state.loading || this.state.autoLoading)
                        && <div className="mainpage-overlay"><Spinner /></div>}
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    serverErr: state.media.mediaObjects.serverErr,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    searchObjects: (data) => dispatch(actions.searchObjects(data)),
    searchWorks: (data) => dispatch(actions.searchWorks(data)),
    getWork: (data) => dispatch(actions.getWork(data)),
    getWorkdetailsByPriref: (data) => dispatch(actions.getWorkdetailsByPriref(data)),
    getItemdetailsByPriref: (data) => dispatch(actions.getItemdetailsByPriref(data)),
    getObjectdetailsByPriref: (data) => dispatch(actions.getObjectdetailsByPriref(data)),
    getLaneTree: () => dispatch(actions.getLaneTree()),
    getObject: (obj) => dispatch(actions.getObject(obj)),
    getItem: (obj) => dispatch(actions.getItem(obj)),
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(MainPage))));


